import React from 'react';

import Payouts from '../Payouts/Payouts'
import ProposedChanges from '../ProposedChanges/ProposedChanges'

class CurrentSeason extends React.Component {
    render() {
        return (
            <div id="CurrentSeasonContainer">
                <h2>2022 Season</h2>
                {/* <h3>2022 Proposed Rule Changes</h3>
                <ProposedChanges/> */}
                <Payouts/>
            </div>
        );
    }
}

export default CurrentSeason;